import {take, put, call} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as sasdActionTypes from '../sasdActionTypes';
import sendAttachmentsWithAssignmentFlow from '../../service-cases/sagas/sendAttachmentsWithAssignmentFlow';

/**
 * Update SASD commissioning flow
 */
const updateSASDCommissioningFlow = function* updateSASDCommissioningFlow() {
    while (true) {
        const {payload} = yield take(sasdActionTypes.SUBMIT_SASD_COMMISSIONING_FORM);
        const {
            serviceAssignmentLineNo,
            serviceAssignmentData,
            serviceCaseId,
            attachmentsToSendWithAssignment,
        } = payload;

        yield call(sendAttachmentsWithAssignmentFlow, {
            caller: sasdActionTypes.SUBMIT_SASD_COMMISSIONING_FORM,
            attachmentsToSendWithAssignment,
            serviceCaseId,
        });


        yield* updateServiceAssignment({
            caller: sasdActionTypes.SUBMIT_SASD_COMMISSIONING_FORM,
            assignmentType: efServiceAssignmentTypes.SUBSTITUTE_DRIVER,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });


        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sasdActionTypes.SUBMIT_SASD_COMMISSIONING_FORM},
        });
    }
};

export default updateSASDCommissioningFlow;
